<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}

html {
  width: 100vw;
  margin: 0;
  background-color: white;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  font-size: 100%; // 16px
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // scroll-behavior: smooth;
  overflow-x: hidden;
}

#app {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; // centers content container on page
  width: 100%;
  // keeps content width constrained for wide windows
  max-width: var(--main-width);
  color: #2c3e50;
  padding: 0;
  margin: 0;
}
</style>
